// Configurazione reCAPTCHA
export const RECAPTCHA_CONFIG = {
  siteKey: '6Lf9yY0rAAAAADdqXPCQ1rrSyfiedZr2mG0Fls2C',
  secretKey: '6Lf9yY0rAAAAAIqJt_XZ2YD9rTW_1ic2SgvXls2w', // Solo per verifiche lato server
};

// Funzione per verificare il token reCAPTCHA (da implementare lato server)
export const verifyRecaptchaToken = async (token: string): Promise<boolean> => {
  try {
    const response = await fetch('https://www.google.com/recaptcha/api/siteverify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: `secret=${RECAPTCHA_CONFIG.secretKey}&response=${token}`,
    });

    const data = await response.json();
    return data.success;
  } catch (error) {
    console.error('Errore verifica reCAPTCHA:', error);
    return false;
  }
}; 